import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
import { NgForm, FormsModule } from "@angular/forms";
import { ChangeDetectionStrategy, ViewChild, TemplateRef } from '@angular/core';
import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours, } from 'date-fns';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
declare var jQuery: any;
declare var $: any;
import * as moment from 'moment'

import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView,
} from 'angular-calendar';
const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
};
@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss']
})
export class EventComponent implements OnInit {

  evnetList: any = "";
  evnet: any = "";
  whatsNew: any = "";
  eventSingle: any = "";
  eventrequest: any = {};
  contactRequest: any = {};
  contactError: any;
  contactSuccess: any;
  bannertitle: any = "";

  dateList: any = [];
  next_btn: boolean = true;
  matchvalue: any = 0;
  total: any = 0;
  first_name: any;
  first_image: any;
  date_time: any;
  second_name: any;
  second_image: any;
  startdate: any = [];
  bannerrequest: any = {};
  bannerList: any = "";
  currenttab: any = "";
  storeurl: any = "";
  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;

  view: CalendarView = CalendarView.Month;

  CalendarView = CalendarView;

  viewDate: Date = new Date();

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  actions: CalendarEventAction[] = [
    {
      label: '<i class="fas fa-fw fa-pencil-alt"></i>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        //this.handleEvent('Edited', event);
      },
    },
    {
      label: '<i class="fas fa-fw fa-trash-alt"></i>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        this.handleEvent('Deleted', event);
      },
    },
  ];

  refresh: Subject<any> = new Subject();

  events: CalendarEvent[] = [
    {
      start: subDays(startOfDay(this.startdate), 1),
      end: addDays(this.startdate, 1),
      title: 'A 3 day event',
      color: colors.red,
      actions: this.actions,
      allDay: true,
      resizable: {
        beforeStart: true,
        afterEnd: true,
      },
      draggable: true,
    },
    {
      start: startOfDay(new Date()),
      title: 'An event with no end date',
      color: colors.yellow,
      actions: this.actions,
    },
    {
      start: subDays(endOfMonth(new Date()), 3),
      end: addDays(endOfMonth(new Date()), 3),
      title: 'A long event that spans 2 months',
      color: colors.blue,
      allDay: true,
    },
    {
      start: addHours(startOfDay(new Date()), 2),
      end: addHours(new Date(), 2),
      title: 'A draggable and resizable event',
      color: colors.yellow,
      actions: this.actions,
      resizable: {
        beforeStart: true,
        afterEnd: true,
      },
      draggable: true,
    },
  ];

  activeDayIsOpen: boolean = true;

  constructor(private allpagesService: AllPageService,
    private activatedRoute: ActivatedRoute,
    private router: Router,) { }
  slideconferenceConfig = {
    //dots: true,
    infinite: true,
    arrows: true,
    slidesToShow: 1,
    autoplay: false,
    speed: 500,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  slidetestimonialsConfig = {
    dots: true,
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    autoplay: false,
    speed: 500,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  ngOnInit() {


    this.allpagesService.getEventtype().then((data) => {
      this.evnet = data;
      //console.log(this.evnet); 
    });

    this.activatedRoute.params.subscribe((data) => {
      if (data.slug) {
        this.eventload(data.slug);
        this.storeurl = data.slug;
        //this.newsRequest = data.slug;
      }
      if (data.tab) {
        this.currenttab = data.tab;
        //this.newsRequest = data.slug;
      }
    });

    this.activatedRoute.params.subscribe((data) => {
      if (data.tab) {
        this.activetab(data.tab);
			  console.log(data.tab);
      }
    });

    this.allpagesService.getEventWhatsnew().then((data) => {
      this.whatsNew = data;
      //console.warn(this.whatsNew);
    });


  }
  
  activetab(tab){
    jQuery(".inner-name").removeClass('active');
	  jQuery(".inner-main-content").removeClass('active');
    if(tab == 'west-end-shows'){
      //alert("hello");
      		jQuery("#evnet-2").addClass('active');
      		jQuery("#evnet-2-content").addClass("active");		
    }else if(tab == 'outdoor-cinema'){
      jQuery("#evnet-3").addClass('active');
      jQuery("#evnet-3-content").addClass("active");	
    }
    
    else if(tab == 'fireworks-evening'){
      jQuery("#evnet-4").addClass('active');
      jQuery("#evnet-4-content").addClass("active");	
    }
    else if(tab == 'christmas-parties'){
      jQuery("#evnet-9").addClass('active');
      jQuery("#evnet-9-content").addClass("active");	
    }else if(tab == 'foundation-events'){
      jQuery("#evnet-10").addClass('active');
      jQuery("#evnet-10-content").addClass("active");	
    }else if(tab == 'weddings'){
      jQuery("#evnet-5").addClass('active');
      jQuery("#evnet-5-content").addClass("active");	
    }else if(tab == 'corporate-days'){
      jQuery("#evnet-7").addClass('active');
      jQuery("#evnet-7-content").addClass("active");	
    }else if(tab == 'conferences-and-events'){
      jQuery("#evnet-6").addClass('active');
      jQuery("#evnet-6-content").addClass("active");	
    }
    else if(tab == 'suites'){
      jQuery("#evnet-8").addClass('active');
      jQuery("#evnet-8-content").addClass("active");	
    }
    else if(tab == 'concerts'){
      jQuery("#evnet-1").addClass('active');
      jQuery("#evnet-1-content").addClass("active");	
    }
    else if(tab == 'weddings'){
      jQuery("#evnet-5").addClass('active');
      jQuery("#evnet-5-content").addClass("active");	
    }
    else if(tab == 'events'){
      jQuery("#evnet-1").addClass('active');
      jQuery("#evnet-1-content").addClass("active");	
    }
   
    else{
      		jQuery("#evnet-1").addClass('active');
      		jQuery("#evnet-1-content").addClass("active");
      	}
  }
  

  // tabactive(tab) {
	// 	jQuery(".inner-name").removeClass('active');
	// 	jQuery(".inner-main-content").removeClass('active');
	// 	if(tab == 'history'){
	// 		jQuery("#history").addClass('active');
	// 		jQuery("#history-content").addClass("active");		
	// 	}else if(tab == 'meet-the-board'){
	// 		jQuery("#meet-the-board").addClass('active');
	// 		jQuery("#meet-the-board-content").addClass("active");
	// 	}else if(tab == 'governance'){
	// 		jQuery("#governance").addClass('active');
	// 		jQuery("#governance-content").addClass("active");
	// 	}else if(tab == 'safeguarding'){
	// 		jQuery("#safeguarding").addClass('active');
	// 		jQuery("#safeguarding-content").addClass("active");
	// 	}else if(tab == 'friends-of-grace-road'){
	// 		jQuery("#friend-grace-road").addClass('active');
	// 		jQuery("#friend-grace-road-content").addClass("active");
	// 	}else if(tab == 'honours'){
	// 		jQuery("#honours").addClass('active');
	// 		jQuery("#honours-content").addClass("active");
	// 	}else if(tab == 'museum'){
	// 		jQuery("#museum").addClass('active');
	// 		jQuery("#museum-content").addClass("active");
	// 	}
	// 	else{
	// 		jQuery("#about-the-running").addClass('active');
	// 		jQuery("#about-the-running-content").addClass("active");
	// 	}
	// }

  clubContactus(form: NgForm) {
    if (form.valid) {

      let request: any = {};
      request = Object.assign({}, this.contactRequest);
      this.allpagesService.getClubContactus(request).then((res) => {

        if (res.status == 0) {
          this.contactError = res.message;
        } else {
          this.contactSuccess = res.message;
          form.reset();
        }
      })
        .catch((err) => {
          this.contactError = err.res.message;
        });
    }
  }

  eventload(eventslug) {
    console.log(eventslug);

    this.eventrequest = {
      slug: eventslug
    }
    console.warn(this.eventrequest);
    //this.eventrequest.slug = eventslug;
    let request = Object.assign({}, this.eventrequest)
    this.allpagesService.getEventtype(request).then((data) => {
      this.evnetList = data.data || {};
      setTimeout(() => {


        jQuery(".event-conference-btn a.event-contact").click(function () {
          jQuery(".event-contact-section").addClass("ok");
        });
        
          jQuery(".inner-name").click(function () {
            if (jQuery(this).hasClass('open')) {              
              // do nothing
            } else {
             
              var textid = jQuery(this).attr('id');
              jQuery(".inner-name").removeClass('open');
              jQuery(this).addClass('open');
              jQuery(".inner-main-content").removeClass('open');
              jQuery("#" + textid + "-contenttext").addClass("open");
            }
            return false;
          });
        


      }, 1000);
      if(this.currenttab == '' && this.evnetList.event.length > 0){
        this.currenttab = this.evnetList.event[0].slug; 
      }
      this.bannertitle = this.evnetList.event[0].title;
      this.loadBanner();
      console.warn(this.evnetList);
      

    });
    //   console.log(eventslug);
    // this.allpagesService.getEventtype().then((data) => {
    // 	this.evnetList = data;

    // 	console.warn(this.evnetList);


    // });
  }

  tabactive(id: any, rel: any) {
    if (jQuery('#evnet-' + id).hasClass('active')) {
      //alert(id);
      // do nothing
      this.loadBanner();
    } else {
      //alert(id);
      var tabid = 'evnet-' + id;
      console.log(tabid);
      this.bannertitle = rel;
      this.loadBanner();
      var imgid = 'evnet-' + id;
      console.warn(this.bannertitle);
      jQuery(".courses-name").removeClass('active');
      jQuery('#evnet-' + id).addClass('active');
      jQuery(".course-main-content").removeClass('active');
      jQuery(".banner-top-content").removeClass('active');
      jQuery("#" + tabid + "-content").addClass("active");
      jQuery("#" + imgid + "-contentimg").addClass("active");
      jQuery("#" + tabid + "-content").find(".inner-name:first").addClass("open");
			jQuery("#" + tabid + "-content").find(".inner-main-content:first").addClass("open");
    }
    return false;
  }

  loadBanner() {
    this.bannerrequest = {
      title: this.bannertitle
    };
    let request = Object.assign({}, this.bannerrequest);
    this.allpagesService.getBannerList(request).then((data: any) => {
      this.bannerList = data.data[0];
      console.log(this.bannerList);
    });

  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  handleEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
    //this.modal.open(this.modalContent, { size: 'lg' });
  }

  addEvent(): void {
    this.events = [
      ...this.events,
      {
        title: 'New event',
        start: startOfDay(new Date()),
        end: endOfDay(new Date()),
        color: colors.red,
        draggable: true,
        resizable: {
          beforeStart: true,
          afterEnd: true,
        },
      },
    ];
  }

  deleteEvent(eventToDelete: CalendarEvent) {
    this.events = this.events.filter((event) => event !== eventToDelete);
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

}
